


















import Vue, { PropType } from "vue";
import CommentListOnSlideMenu from "@/components/organisms/CommentListOnSlideMenu.vue";
import SharedManuscriptListOnSlideMenu from "@/components/organisms/SharedManuscriptListOnSlideMenu.vue";
import SharedLinkListOnSlideMenu from "@/components/organisms/SharedLinkListOnSlideMenu.vue";
import CommentIcon from "@/components/atoms/CommentIcon.vue";
import CloseIcon from "@/components/atoms/CloseIcon.vue";
import { Comment as CommentDexie } from "@/lib/indexeddb";
import { User } from "@/lib/models";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CommentListOnSlideMenu,
    SharedManuscriptListOnSlideMenu,
    SharedLinkListOnSlideMenu,
    CommentIcon,
    CloseIcon,
  },
  props: {
    novelId: {
      type: String as PropType<string>,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onOpenTagClick() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
  },
  computed: {
    user() {
      return this.$store.getters["userModule/user"] as User;
    },
    selectedSharedLinkId() {
      return this.$store.getters["sharedLinkModule/selectedSharedLinkId"];
    },
    selectedManuscriptKey() {
      return this.$store.getters["sharedLinkModule/selectedManuscriptKey"];
    },
    hasUnreadComment() {
      const { novelId } = this;
      const { userId } = this.user as User;
      const unreadCommentList = this.$store.getters["sharedLinkModule/unreadCommentList"](
        userId,
        novelId
      ) as CommentDexie[];
      return !!unreadCommentList.length;
    },
  },
  destroyed() {
    this.$store.dispatch("sharedLinkModule/initializeSelectedSharedLink");
    this.$store.dispatch("sharedLinkModule/initializeSelectedManuscript");
  },
  watch: {
    $route: "closeMenu",
  },
});

interface Props {
  novelId: string;
}

interface Data {
  isOpen: Boolean;
}

interface Methods {
  onOpenTagClick: () => void;
  closeMenu: () => void;
}

interface Computed {
  user: User;
  selectedSharedLinkId: string;
  selectedManuscriptKey: string;
  hasUnreadComment: boolean;
}
